import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { TransferSummary } from "../../transfers.types";
import { requestGetTransferSummary } from "./getTransferSummary.request";

const useGetTransferSummary = (
  options?: QueryOptions<TransferSummary, ApiServiceError<ApiError>>,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["transfer-admin", "summary"],
    queryFn: async () => await requestGetTransferSummary(),
    ...options,
  });

  return { summary: data, ...rest };
};

export default useGetTransferSummary;
